import React, { useState } from 'react';
import axios from 'axios';

import "../../CssFiles/downloads.css"

const BureauReportForm = () => {
    const [user, setUser] = useState('');
    const [password, setPassword] = useState('');
    const [reportType, setReportType] = useState("cons");

    const handleReportTypeChange = (e) => {
        setReportType(e.target.value);
        console.log("Selected Report Type:", e.target.value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        var downUrl = '';
        var host = window.location.hostname;
        if (host == 'www.hellotrade.com') {
            downUrl = 'https://www.hellotrade.com/api/v1/downloadCSV';
        }
        else {
            downUrl = 'https://dev.hellotrade.com/api/v1/downloadCSV';
        }

        try {
            const response = await axios.post(downUrl, {
                user,
                password,
                reportType,
            }, {
                responseType: 'blob'
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'report.csv');
            document.body.appendChild(link);
            link.click();
            link.remove();

        } catch (error) {
            console.error('Error downloading file:', error);
            // alert('Failed to download the report. Please try again.');
        }
    };

    return (
        <form onSubmit={handleSubmit} id='download-form'>
            <table border="1">
                <tr>
                    <td align="center" colSpan="2" className='heading'>CSV Report</td>
                </tr>
                <tr>
                    <td>USERNAME :</td>
                    <td>
                        <input
                            type="text"
                            name="user"
                            id="user"
                            maxLength={15}
                            value={user}
                            onChange={(e) => setUser(e.target.value)}
                        />
                    </td>
                </tr>
                <tr>
                    <td>PASSWORD :</td>
                    <td>
                        <input
                            type="password"
                            name="password"
                            id="password"
                            maxLength={15}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </td>
                </tr>
                <tr>
                    <td>Report Type :</td>
                    <td>
                        <label>
                            <input
                                type="radio"
                                name="reportType"
                                value="cons"
                                onChange={handleReportTypeChange}
                                required
                            /> Consolidated
                        </label>
                        <label>
                            <input
                                type="radio"
                                name="reportType"
                                value="dis"
                                onChange={handleReportTypeChange}
                                required
                            /> Distributed
                        </label>

                        <label>
                            <input
                                type="radio"
                                name="reportType"
                                value="add"
                                onChange={handleReportTypeChange}
                                required
                            /> Additional Info
                        </label>
                    </td>
                </tr>
                <tr>
                    <td align="center" colSpan="2">
                        <input type="submit" name="status_btn" value="Download Report" onClick={handleSubmit}/>
                    </td>
                </tr>
            </table>
        </form>
    );
};

export default BureauReportForm;
